import { render, staticRenderFns } from "./promot-common.vue?vue&type=template&id=62f1df30"
import script from "./promot-common.vue?vue&type=script&lang=js"
export * from "./promot-common.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports